import React, { useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import { AUIModal } from '@ancert/aui-modal';
import AUIButton from '@ancert/aui-button';
import { classNames } from 'primereact/utils';
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import TIPO_ADJUNTO from '../../lib/adjuntos.enum';

const AUDIO_CONTAINER_ID = 'c-sii-audio-recorder__container';
const AUDIO_ID = 'audio-recorded';

const AudioRecorderModal = ({ show, onClose, onAccept }) => {
  const [accepted, setAccepted] = useState(false);
  const recorderControls = useAudioRecorder({
    noiseSuppression: true,
    echoCancellation: true,
  });
  const { isRecording, startRecording, stopRecording } = recorderControls;
  const [recordingBlob, setRecordingBlob] = useState(null);

  const addAudioElement = (blob) => {
    const url = URL.createObjectURL(blob);
    const audio = document.createElement('audio');
    audio.setAttribute('id', AUDIO_ID);
    audio.src = url;
    audio.controls = true;
    document.getElementById(AUDIO_CONTAINER_ID).appendChild(audio);
    setRecordingBlob(blob);
  };

  const deleteRecord = () => {
    setRecordingBlob(null);
    const audio = document.getElementById(AUDIO_ID);
    if (!audio) {
      return;
    }
    audio.removeAttribute('src');
    audio.removeAttribute('controls');
    const parent = document.getElementById(AUDIO_CONTAINER_ID);
    parent.removeChild(audio);
  };

  useEffect(() => {
    deleteRecord();
  }, [show]);

  const onClickRecord = () => {
    if (isRecording) {
      stopRecording();
      return;
    }
    deleteRecord();
    startRecording();
  };

  const onCloseModal = () => {
    stopRecording();
    deleteRecord();
    onClose();
  };

  const onClickAccept = () => {
    const audioObj = { name: 'Archivo-audio.mp3', blob: recordingBlob, type: TIPO_ADJUNTO.MP3 };
    onAccept(audioObj);
  };

  const sideCheckbox = {
    id: 'checkbox',
    defaultChecked: false,
    label: 'Acepto la cesión del documento de audio para formalizar la denuncia.',
    onChange: () => setAccepted(!accepted),
  };

  const buttons = [
    {
      id: 'primary',
      mode: 'primary',
      label: 'Aceptar',
      onClick: onClickAccept,
      disabled: !accepted || !recordingBlob,
    },
    {
      id: 'tertiary',
      mode: 'tertiary',
      label: 'Cancelar',
      onClick: onCloseModal,
      disabled: false,
    },
  ];

  const className = classNames('c-sii-audio-recorder', {
    [`c-sii-audio-recorder--firefox`]: navigator.userAgent.toLowerCase().includes('firefox'),
  });
  const classNameComponent = classNames('c-sii-audio-recorder__component', {
    [`c-sii-audio-recorder__component--visibility`]: isRecording,
  });

  return (
    <AUIModal
      size="xl"
      title="Grabar archivo de audio"
      show={show}
      actionButtons={buttons}
      sideCheckbox={sideCheckbox}
      autoHeight
      onClose={onCloseModal}
    >
      <div className={className}>
        <div id={AUDIO_CONTAINER_ID} className="c-sii-audio-recorder__container">
          <div className={classNameComponent}>
            <AudioRecorder
              showVisualizer
              onRecordingComplete={(blob) => addAudioElement(blob)}
              recorderControls={recorderControls}
            />
          </div>
        </div>
        <div className="c-sii-audio-recorder__buttons">
          <AUIButton label="Borrar audio" mode="tertiary" onClick={deleteRecord} />
          <AUIButton
            label={isRecording ? 'Detener grabación' : 'Iniciar grabación'}
            mode={isRecording ? 'danger' : 'secondary'}
            onClick={onClickRecord}
          />
        </div>
      </div>
    </AUIModal>
  );
};
AudioRecorderModal.propTypes = {
  show: bool,
  onAccept: func,
  onClose: func,
};
AudioRecorderModal.defaultProps = {
  show: false,
  onAccept: null,
  onClose: null,
};

export default AudioRecorderModal;
